import Video from '../assets/videos/plans-2.mp4'

const VideoBanner = () => {
  return (
    <video
      className="VideoBanner"
      src={Video}
      alt="Vida Cowork"
      title="Vida Cowork"
      autoPlay
      loop
      muted
    />
  )
}

export default VideoBanner